<app-interview-sidebar>
  <div class="goal-page full-width vertical">
    <div class="page-header full-width horizontal seperate bottom">
      <div>
        <div class="page-title margin-top vertical">Target Position</div>
        <div class="description">
          AI assistant will understand the job description and requirements to optimize the guidance for you.
        </div>
      </div>
      <button nz-button nzType="primary" nzSize="default" (click)="onNewGoalBtnClick()">
        <span nz-icon style="font-size: 16px" class="material-icons-outlined">add</span>
        Add Position
      </button>
    </div>
    <div class="basic-block">
      <nz-table #goalTable [nzData]="goalList()" [nzPaginationType]="'small'" [nzPageSize]="8">
        <thead>
          <tr>
            <th>Company</th>
            <th>Position</th>
            <th [ngStyle]="{ minWidth: '140px' }">Company Info</th>
            <th>Job Description</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (data of goalTable.data; track data.id; let i = $index) {
            <tr>
              <td>{{ data.subData.company }}</td>
              <td>{{ data.subData.position }}</td>
              <td>{{ data.subData.companyDetails | truncate: 100 }}</td>
              <td>{{ data.subData.jobDescription | truncate: 100 }}</td>
              <td>
                <div class="horizontal">
                  <button nz-button nzType="text" [matTooltip]="'Edit'" (click)="onEditGoalClick(data)">
                    <span nz-icon style="font-size: 16px" class="material-icons-outlined">edit</span>
                  </button>
                  <button
                    nz-button
                    nzType="text"
                    [matTooltip]="'Remove'"
                    [nzDanger]="true"
                    nz-popconfirm
                    nzOkText="Remove"
                    nzPopconfirmTitle="Are you sure you want to remove this position?"
                    nzPopconfirmPlacement="bottom"
                    (nzOnConfirm)="onDeleteGoalClick(i)"
                  >
                    <span nz-icon style="font-size: 16px" class="material-icons-outlined">delete_forever</span>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  </div>
</app-interview-sidebar>

<app-new-edit-goal
  [goalSubData]="goalSubData"
  [selectedGoal]="selectedGoal"
  [(isNewEditGoalVisible)]="isNewEditGoalVisible"
  [isEditGoal]="isEditGoal"
></app-new-edit-goal>
